export enum TabIndex {
  NONE = "none",
  SIZE = "size",
  COLOR = "color",
}

export type PanelProps = {
  setSelectedTabeIndex: (tabIndex: TabIndex) => void;
};
